import React from 'react';
import { useNavigate } from 'react-router-dom';
import ResponsiveTable from './ResponsiveTable';

function ArtistsTable({ data, totalCount, currentPage, pageSize, searchKeyword }) {
  const navigate = useNavigate();
  const defaultImage =
    'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg';

  const getImageUrl = (url) => {
    if (!url) return defaultImage;
    return url.startsWith('http') ? url : defaultImage;
  };

  const columns = React.useMemo(
    () => [
      {
        Header: '순번',
        id: 'row',
        Cell: ({ row }) =>
          totalCount - ((currentPage - 1) * pageSize + row.index),
      },
      {
        Header: 'ID',
        accessor: 'artistId',
      },
      {
        Header: () => (
          <div className="whitespace-nowrap text-center">프로필사진</div>
        ),
        accessor: 'image',
        Cell: ({ row }) => (
          <img
            src={getImageUrl(row.original.image)}
            alt={row.original.nameKr}
            className="w-12 h-12 rounded-full object-cover mx-auto shadow border border-white/[0.08]"
          />
        ),
      },
      {
        Header: '아티스트명',
        accessor: 'nameKr',
        Cell: ({ row }) => (
          <span
            className="font-bold text-sky-400 cursor-pointer hover:underline"
            onClick={() => {
              const searchParam = searchKeyword ? `&search=${encodeURIComponent(searchKeyword)}` : '';
              navigate(`/Artists/${row.original.id}?page=${currentPage}${searchParam}`);
            }}>
            {row.original.nameKr}
          </span>
        ),
      },
      // {
      //   Header: '권리사',
      //   accessor: 'displayClient',
      //   Cell: ({ value }) => <span>{value || '-'}</span>,
      // },
      {
        Header: '권리사',
        accessor: 'displayClient',
        Cell: ({ row }) => {
          const name = row.original.displayClient || '-';
          const id = row.original.displayClientId || '-';
          return (
            <span>
              {name} <span className="text-slate-500 text-sm">({id})</span>
            </span>
          );
        },
      },
    ],
    [navigate, totalCount, currentPage, pageSize, searchKeyword]
  );

  return (
    <ResponsiveTable
      columns={columns}
      data={data}
      visibleOnMobile={['row', 'artistId', 'image', 'nameKr']}
    />
  );
}

export default ArtistsTable;
